"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var providers_1 = require("./providers");

var AutoNationProvider_1 = __importDefault(require("./providers/AutoNationProvider"));

var BingProvider_1 = __importDefault(require("./providers/BingProvider"));

var FacebookPixel_1 = __importDefault(require("./providers/FacebookPixel"));

var FCA_1 = __importDefault(require("./providers/FCA"));

var HyundaiProvider_1 = __importDefault(require("./providers/HyundaiProvider"));

var NissanProvider_1 = __importDefault(require("./providers/NissanProvider"));

var Engine =
/** @class */
function () {
  function Engine(config) {
    var _this = this;

    this.callAnalyticsProviders = function (dealId, vehicles, callable) {
      if (!dealId || !vehicles || !Array.isArray(vehicles)) {
        return;
      }

      vehicles.forEach(function (vehicle) {
        if (!vehicle) {
          return;
        }

        _this.providers.forEach(function (provider) {
          return callable(provider, dealId, vehicle);
        });
      });
    };

    this.providers = config.taggers.map(function (tagger) {
      return _this.createAnalyticsProviders(tagger, config);
    });
    this.config = config;
  }

  Engine.prototype.updateProvider = function (tagger) {
    var idx = this.providers.findIndex(function (p) {
      return p.name === tagger.name;
    });
    var provider = this.createAnalyticsProviders(tagger, this.config);

    if (idx === -1) {
      this.providers.push(provider);
    } else {
      this.providers[idx] = provider;
    }
  };
  /**
   * Should be called on the first page view of a session. (Could be fired more than once over the life of a Deal)
   * Should be fired as soon as the Deal has a UUID assigned.
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.initialClick = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.initialClick(dealId, vehicle);
    });
  };
  /**
   * Should be called when a session is closed.
   * For example, when the whole window or tab is closed, or when the Electric modal is closed.
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.dropSave = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.dropSave(dealId, vehicle);
    });
  };
  /**
   * Should be called when the user expresses *intent* to value their trade-in.
   * This could be as early as when they answer "yes" to "do you have a trade-in".
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.tradeInStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.tradeInStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when we *show* the user trade-in value estimates.
   * The user does not have to choose between the conditions yet.
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.tradeInEstimate = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.tradeInEstimate(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer *accepts* their trade-in value.
   * For us, this means when they choose a "condition" and the value starts being used in loan/lease calculations.
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.tradeInComplete = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.tradeInComplete(dealId, vehicle);
    });
  };
  /**
   * Should be called when a user first engages with any payment calculator input.
   * This could be achieved by changing a value such as down payment
   * or estimated credit score or by changing a slider bar setting.
   * Event should not be fired until a user interacts with the payment calculator
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.calculationStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.calculationStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when a user accepts payment terms and moves on to the next step.
   * Note that it *is* possible to fire calculationFinish without a calculationStart
   * if the user chooses to move on with the default selections
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.calculationFinish = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.calculationFinish(dealId, vehicle);
    });
  };
  /**
   * Should be called when a user *begins* to enter data into any "lead" input
   * (name, email, phone)
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.leadFormStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.leadFormStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when a user has submitted all fields that are required to generate a sales lead.
   * In Online Shopper, this is person.first_name, person.last_name,
   * and at least one of person.email or person.mobile_phone
   * @param  dealId
   * @param  vehicles
   * @return
   */


  Engine.prototype.leadFormFinish = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.leadFormFinish(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer has moved to a place they can no longer alter their offer.
   * This is fired at the same time as leadFormFinish in Electric
   * This is fired at the same time as calculationFinish in Redline
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.paymentOfferSelected = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.paymentOfferSelected(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer completes scheduling *any* appointment
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.appointmentScheduled = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.appointmentScheduled(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer completes a credit application and we receive a tracking ID from the credit system
   * @TODO: ONSHOP-5263 obsolete, should be replaced by only calls to softPullCreditAppComplete OR hardPullCreditAppComplete,
   * @param  dealId
   * @param  vehicles
   * @param  applicationId
   */


  Engine.prototype.creditAppComplete = function (dealId, vehicles, applicationId) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.creditAppComplete(dealId, vehicle, applicationId);
    });
  };
  /**
   * Should be called when the customer expresses intent to complete a soft pull credit application
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.softPullCreditAppStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.softPullCreditAppStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer successfully completes a Soft credit application
   * and we receive a tracking ID
   * @param  dealId
   * @param  vehicles
   * @param  applicationId
   */


  Engine.prototype.softPullCreditAppComplete = function (dealId, vehicles, applicationId) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.softPullCreditAppComplete(dealId, vehicle, applicationId);
    });
  };
  /**
   * Should be called when the customer expresses intent to complete a hard pull credit application
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.hardPullCreditAppStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.hardPullCreditAppStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when the customer successfully completes a Hard credit application
   * and we receive a tracking ID
   * @param  dealId
   * @param  vehicles
   * @param  applicationId
   */


  Engine.prototype.hardPullCreditAppComplete = function (dealId, vehicles, applicationId) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.hardPullCreditAppComplete(dealId, vehicle, applicationId);
    });
  };
  /**
   * Should be called when you *leave* the GAP Insurance page in Redline,
   * whether you add it to this vehicle or not.
   * @param  dealId
   * @param  vehicles
   */


  Engine.prototype.FAndIFinish = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.FAndIFinish(dealId, vehicle);
    });
  };
  /**
   * Should be called when the user begins filling out the reserve vehicle form
   */


  Engine.prototype.reserveVehicleFormStart = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.reserveVehicleFormStart(dealId, vehicle);
    });
  };
  /**
   * Should be called when the user finishes filling out the reserve vehicle form
   */


  Engine.prototype.reserveVehicleFormFinish = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.reserveVehicleFormFinish(dealId, vehicle);
    });
  };
  /**
   * Should be called when user clicks on the CTA button to build a new deal only and the deal creation is successful
   */


  Engine.prototype.buildNewPayment = function () {
    this.providers.forEach(function (p) {
      return p.buildNewPayment();
    });
  };
  /**
   * Should be called after a successful sign in to an existing garage,
   * But only if the unlock starts from the Garage flyout
   */


  Engine.prototype.signInToGarageGarageIcon = function (dealId) {
    this.providers.forEach(function (p) {
      return p.signInToGarageGarageIcon(dealId);
    });
  };
  /**
   * Should be called when the user clicks "Save Payment" to complete the Payment Builder page
   * (at the same time as calculationFinish in Electric, Unused in Redline)
   */


  Engine.prototype.savesPayment = function () {
    this.providers.forEach(function (p) {
      return p.savesPayment();
    });
  };
  /**
   * Should be called when the user chooses to Skip the hard credit app.
   */


  Engine.prototype.skipCreditApp = function () {
    this.providers.forEach(function (p) {
      return p.skipCreditApp();
    });
  };
  /**
   * This is called when the user navigates from the first page of Electric's hard Credit App to the second
   * @TODO: ONSHOP-5264 This needs to be replaced with a more flexible, payload-bearing event
   */


  Engine.prototype.creditAppPrimaryPageTwo = function () {
    this.providers.forEach(function (p) {
      return p.creditAppPrimaryPageTwo();
    });
  };
  /**
   * Should be called when the user affirms they have a cosigner in the hard credit app
   */


  Engine.prototype.cosignerYes = function () {
    this.providers.forEach(function (p) {
      return p.cosignerYes();
    });
  };
  /**
   * Should be called when the user clicks "Explore Upgrades" in the Continue Deal screen (after grid) in Electric only
   * Right now there's no Skip option here, I'm not sure I'd consider this intent in the same way hardPullCreditAppStart is
   */


  Engine.prototype.exploreUpgrades = function () {
    this.providers.forEach(function (p) {
      return p.exploreUpgrades();
    });
  };
  /**
   * Should be called when the user clicks "No thanks, I will accessorize later" under the accessory list
   * in the Continue Deal screen in Electric only
   * Unlike skipCreditApp, you had to exploreUpgrades to get to the UI element
   */


  Engine.prototype.skipUpgrades = function () {
    this.providers.forEach(function (p) {
      return p.skipUpgrades();
    });
  };
  /**
   * Should be called when the user chooses one vehicle to Continue Deal (leave the grid) in Electric
   * The backend API will use this to choose the "favorite" vehicle that is sent in ADF
   * @param  vin  VIN of the vehicle that was chosen to continue
   */


  Engine.prototype.continueDeal = function (vin) {
    this.providers.forEach(function (p) {
      return p.continueDeal(vin);
    });
  };
  /**
   * Should be called when the user adds an accessory to their vehicle
   * @param  id   accessory's 'id' property
   */


  Engine.prototype.addUpgrade = function (id) {
    this.providers.forEach(function (p) {
      return p.addUpgrade(id);
    });
  };
  /**
   * Should be called when the user selects a date in the delivery/pick-up form
   * Always fired before appointmentScheduled
   * @param  date
   * @return
   */


  Engine.prototype.pickDeliveryDate = function (date) {
    this.providers.forEach(function (p) {
      return p.pickDeliveryDate(date);
    });
  };
  /**
   * Should be called when the user selects a time of day in the delivery/pick-up form
   * Always fired before appointmentScheduled
   * @param  time
   * @return
   */


  Engine.prototype.pickDeliveryTime = function (time) {
    this.providers.forEach(function (p) {
      return p.pickDeliveryTime(time);
    });
  };
  /**
   * Should be called when the interface "feels like" it has rendered a new page of content.
   * In Redline, this fires every time the user Continues to a new Subform
   * @param  pagePath
   * @return
   */


  Engine.prototype.virtualPageView = function (pagePath) {
    this.providers.forEach(function (p) {
      return p.virtualPageView(pagePath);
    });
  };
  /**
   * Should be called when the user clicks on “Send Garage Key”
   */


  Engine.prototype.signInStart = function () {
    this.providers.forEach(function (p) {
      return p.signInStart();
    });
  };
  /**
   * Should be called when PIN is confirmed
   */


  Engine.prototype.signInComplete = function (dealId) {
    this.providers.forEach(function (p) {
      return p.signInComplete(dealId);
    });
  };
  /**
   * Should be called when payment builder loads (Electric Only)
   */


  Engine.prototype.paymentBuilderLoad = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.paymentBuilderLoad(dealId, vehicle);
    });
  };
  /**
   * Should be called when the Payment Options subform loads (Redline Only)
   */


  Engine.prototype.paymentOptionsLoad = function (dealId, vehicles) {
    this.callAnalyticsProviders(dealId, vehicles, function (provider, dealId, vehicle) {
      return provider.paymentOptionsLoad(dealId, vehicle);
    });
  };

  Engine.prototype.createAnalyticsProviders = function (tagger, config) {
    switch (tagger.name) {
      case "sd":
        return new providers_1.ShiftDigitalProvider(config, tagger.payload);

      case "os":
        return new providers_1.OnlineShopperProvider(tagger.name, tagger.payload);

      case "fca":
        return new FCA_1.default(tagger.name, tagger.payload);

      case "hyundai":
        return new HyundaiProvider_1.default(tagger.name, tagger.payload);

      case "ga":
        return new providers_1.GoogleAnalyticsProvider(tagger.name, tagger.payload);

      case "fp":
        return new FacebookPixel_1.default(tagger.name, tagger.payload);

      case "nissan":
        return new NissanProvider_1.default(tagger.name, tagger.payload);

      case "autonation":
        return new AutoNationProvider_1.default(tagger.name, tagger.payload);

      case "bing":
        return new BingProvider_1.default(tagger.name, tagger.payload);

      default:
        return new providers_1.GenericProvider("genericProvider");
    }
  };

  return Engine;
}();

exports.Engine = Engine;